import { NgClass } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
declare var bootstrap: any;
import Swal from 'sweetalert2';
@Component({
  selector: 'app-rtl-under-whl',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatIcon,
    NgClass,
    RouterLink
  ],
  templateUrl: './rtl-under-whl.component.html',
  styleUrl: './rtl-under-whl.component.scss'
})
export class RtlUnderWhlComponent {
  startpoint = 0;
  search: any;
  totalLoaded = 0;
  total = 0;
  pageNo = 0;
  categoryRes: any;
  categoryId: any;

  assignRTLModal: any
  retailerDetailModal: any
  name: any;

  constructor(
    private userService: UserServiceService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService,
  ) {
    this.setDisplayedColumns();
  }

  distributorId: any

  ngOnInit(): void {
    this.distributorId = this.activatedRoute.snapshot.paramMap.get("wholesalerId")
    this.getSingleWHL()
    this.getCompanyData();

  }
  singleDistributor: any

  getSingleWHL() {
    this.userService.singleDistributor({ _id: this.distributorId }).subscribe({
      next: (v: any) => {
        this.spinner.show()
        if (v.success) {
          this.singleDistributor = v.data
        }
        else {
          console.log(v.message);
        }
      },
      error: (e: any) => {
        this.spinner.hide()
        this.toastr.error(e.message, 'Error')
      },
      complete: () => {
        this.spinner.hide()
      }
    })

  }
  selectedRetailer: any
  selectedRTL(event: any) {
    if (event) {
      let RTLId = event._id
      Swal.fire({
        title: `Assign retailer to ${this.singleDistributor.name}?`,
        text: "Are you sure you want to assign this retailer to the distributor?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Assign Now",
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            companyId: this.companyId,
            _id: RTLId,
            parentDistributorId: this.distributorId
          }
          this.userService.rtlUnderWhlAdd(data).subscribe({
            next: (v: any) => {
              this.spinner.hide()
              if (v.success) {
                this.toastr.success(v.message, 'Success')
                this.hideModel()
                this.getAllRetailers(null)
              }
              else {
                this.spinner.hide()

                this.toastr.error(v.message, 'Error')
              }
            },
            error: (e: any) => {
              this.spinner.hide()
              this.toastr.error(e.message, 'Error')

            },
            complete: () => {
              this.spinner.hide()

            }
          })
        }
      });

    }
  }


  allCompanyDistributorsMini: any

  getAllRetailersMini(): void {
    this.spinner.show()
    this.userService.noAssignRetailersToDis({ companyId: this.companyId, distributorType: this.distributorType }).subscribe({
      next: (res) => {
        this.spinner.hide()
        if (res.success) this.allCompanyDistributorsMini = res.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  companyId: any

  isCompanyLoggedIn: boolean = false

  getCompanyData() {
    let userData = this.userDataService.getData()
    let companyData = userData.company
    if (!!companyData) {
      this.isCompanyLoggedIn = true
      this.companyId = companyData._id
      this.getAllRetailers(null)
    }
    else {
      this.isCompanyLoggedIn = false
      this.getAllRetailers(null);
    }
  }
  debounceTimer: any = null;

  onSearchChange(event: any) {
    const value = event.target.value.trim();
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.name = value || undefined;
      this.getAllRetailers(null);
    }, 200);
  }
  displayedColumns: string[] = [];

  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position', 'name', 'email', 'phone', 'cordinates', 'address', 'action'
    ];
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    const modalElement = document.getElementById('assignRTLModal');
    if (modalElement) {
      this.assignRTLModal = new bootstrap.Modal(modalElement);
    }

    const retailerDetailModalElement = document.getElementById('retailerDetailModal');
    if (retailerDetailModalElement) {
      this.retailerDetailModal = new bootstrap.Modal(retailerDetailModalElement);
    }


  }

  distributorType: any

  openModel(distributorType: any) {
    this.distributorType = distributorType
    this.getAllRetailersMini()
    this.assignRTLModal.show();
  }

  hideModel() {
    this.assignRTLModal.hide();
  }

  singleRetailer: any

  openRetailerDetailModel(retailerId: any) {
    this.userService.singleDistributor({ _id: retailerId }).subscribe((res: any) => {
      if (res.success) {
        this.singleRetailer = res.data
        this.retailerDetailModal.show();
      }

    })
  }

  hideRetailerDetailModel() {
    this.retailerDetailModal.hide();
  }


  dataSource = new MatTableDataSource<any>([]);

  getAllRetailers(event: any) {
    this.spinner.show();
    if (!event) {
      this.startpoint = 0;
      this.dataSource.data = [];
    }
    let data: any = { startpoint: this.startpoint };

    data.companyId = this.companyId;
    data.distributorId = this.distributorId;

    if (this.totalLoaded === 0 || !event || (this.totalLoaded < this.total && event.pageIndex > this.pageNo)
    ) {
      this.userService.rtlUnderWhl(data).subscribe({
        next: (result) => {
          this.spinner.hide();
          if (result.success) {
            this.categoryRes = result;
            this.total = result.total ?? 0;
            this.dataSource.data = [...this.dataSource.data, ...(result.data || [])];
            this.totalLoaded = this.dataSource.data.length;
            this.startpoint = this.totalLoaded;
            this.pageNo = this.paginator?.pageIndex;
            setTimeout(() => {
              this.paginator.length = this.total;
              this.paginator.pageSize = PAGELENGTH;
            }, 10);
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          const errorMsg = e.status === 0
            ? "Server not reachable. Try again later."
            : e.message || 'An unexpected error occurred.';
          this.toastr.error(errorMsg, 'Error');
        },
        complete: () => this.spinner.hide(),
      });
    } else {
      this.spinner.hide();
    }
  }

  switchDistributor(id: any) {
    Swal.fire({
      title: 'Switching...',
      text: 'Distributor is being switched!',
      toast: true,
      position: 'top-end',
      icon: 'success',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true
    });
  }

    removeAssignDistributor(info:any){
     Swal.fire({
        title: "Remove Assigned Distributor ",
        text: "Are you sure you want to remove this distributor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove",
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          const data:any = {
            companyId: this.companyId,
            distributorId: info?.distributorId?._id,
          }
          this.userService.rtlUnderWhlRemove(data).subscribe({
            next: (v: any) => {
              this.spinner.hide()
              if (v.success) {
                this.toastr.success(v.message, 'Success')
                this.getAllRetailers(null)
              }
              else {
                this.spinner.hide()
                this.toastr.error(v.message, 'Error')
              }
            },
            error: (e: any) => {
              this.spinner.hide()
              this.toastr.error(e.message, 'Error')

            },
            complete: () => {
              this.spinner.hide()

            }
          })
        }
      });

  }







}
